import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-banker-group-modal-referral',
  templateUrl: './banker-group-modal-referral.component.html',
  styleUrls: ['./banker-group-modal-referral.component.scss']
})
export class BankerGroupModalReferralComponent implements OnInit {

  public referrals: any = [];
  public is_loading_function: boolean = false;
  @Input() player_uuid: string;
  @Output() closeEvent = new EventEmitter<boolean>();
  constructor(private http: HttpService) { 
  }

  ngOnInit(): void {
    this.init();
  }

  async init() {
    this.is_loading_function = true;
    let rtn:any = await this.http.post("/admin/banker-group/get-referral", {player_uuid: this.player_uuid});
    this.is_loading_function = false;
    if(!rtn.status) {
      this.http.notify(rtn.message);
      return;
    }
    this.referrals = rtn.referrals;
  }

}
